export const TreatmentPhase = {
  flow: 'y',
  round: 'A',
  overflow: 'hidden',
  border: (el, s) => s.status === 'active' ? '1px solid teal' : '1px solid inkBorder',

  PhaseHeader: {
    flow: 'x',
    align: 'center space-between',
    padding: 'Z A',
    cursor: 'pointer',
    background: (el, s) => s.status === 'active' ? 'teal.08' : 'ink',
    onClick: (e, el, s) => s.update({ collapsed: !s.collapsed }),

    HeaderLeft: {
      flow: 'y', gap: 'X',
      PhaseTitle: {
        tag: 'h4',
        text: (el, s) => s.title || 'Phase',
        fontSize: 'Z', fontWeight: '700',
        color: (el, s) => s.status === 'active' ? 'teal' : 'inkText'
      },
      PhaseMeta: {
        text: (el, s) => {
          var rows = s.rows || []
          return rows.length + ' procedures · ' + (s.provider || 'Multiple providers')
        },
        fontSize: 'Y', color: 'inkMuted'
      }
    },

    HeaderRight: {
      flow: 'x', gap: 'Z', align: 'center center',
      StatusBadge: {
        tag: 'span',
        text: (el, s) => s.status || 'pending',
        fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B',
        background: (el, s) => s.status === 'active' ? 'teal.15' : 'inkMid',
        color: (el, s) => s.status === 'active' ? 'teal' : 'inkMuted',
        whiteSpace: 'nowrap'
      },
      Chevron: {
        tag: 'span',
        text: (el, s) => s.collapsed ? '▸' : '▾',
        fontSize: 'Z', color: 'inkMuted', marginLeft: 'Y'
      }
    }
  },

  ProcedureList: {
    flow: 'y', gap: '0',
    show: (el, s) => !s.parent.collapsed,
    background: 'inkMid',
    borderTop: '1px solid inkBorder',

    childExtends: 'TreatmentRow',
    $collection: (el, s) => {
      var rows = s.parent.rows || []
      return rows.map(function (row) {
        return {
          state: {
            tooth: row.tooth,
            procedure: row.description,
            code: row.code,
            provider: row.provider,
            fee: row.fee,
            status: row.status
          }
        }
      })
    }
  },

  PhaseSummary: {
    flow: 'x', align: 'center space-between',
    padding: 'Y A', background: 'inkSurface',
    show: (el, s) => !s.parent.collapsed,
    borderTop: '1px solid inkBorder',

    SummaryLabel: {
      text: '{{ phaseTotal | polyglot }}',
      fontSize: 'Y', fontWeight: '600', color: 'inkMuted'
    },
    SummaryRight: {
      flow: 'x', gap: 'A', align: 'center flex-end',
      SummaryAmount: {
        show: (el, s) => !s.root.chairSideMode,
        text: (el, s) => {
          var rows = s.parent.rows || []
          var total = 0
          rows.forEach(function (r) {
            total += parseFloat(String(r.fee || 0)) || 0
          })
          return '₾' + total.toLocaleString()
        },
        fontSize: 'Z', fontWeight: '700', color: 'teal'
      },
      SummaryCount: {
        text: (el, s) => {
          var rows = s.parent.rows || []
          return rows.length + ' procedures'
        },
        fontSize: 'Y', color: 'inkMuted'
      }
    }
  }
}
